var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 6H13C13.55 6 14 5.55 14 5C14 4.45 13.55 4 13 4H9C8.45 4 8 4.45 8 5C8 5.55 8.45 6 9 6ZM9 10H13C13.55 10 14 9.55 14 9C14 8.45 13.55 8 13 8H9C8.45 8 8 8.45 8 9C8 9.55 8.45 10 9 10ZM9 14H13C13.55 14 14 13.55 14 13C14 12.45 13.55 12 13 12H9C8.45 12 8 12.45 8 13C8 13.55 8.45 14 9 14ZM4 4H6V6H4V4ZM4 8H6V10H4V8ZM4 12H6V14H4V12ZM17 0H1C0.45 0 0 0.45 0 1V17C0 17.55 0.45 18 1 18H17C17.55 18 18 17.55 18 17V1C18 0.45 17.55 0 17 0ZM16 16H2V2H16V16Z",
    fill: "#434656"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.6889445b9aa2caa503950d0d9b278227.svg";
export { ForwardRef as ReactComponent };